import { Note } from '@card-software/library';

export interface ItemMasterProposal {
  id?: string;
  status: number;
  mongoDBCollection: string;
  itemCode: string;
  itemDescription: string;
  notes: Note[];
}

export enum ItemMasterProposalStatus {
  Draft,
  Pending,
  Created,
  Rejected,
  Cancel,
}
